import React, { useEffect, useState } from 'react';
import './App.css';

function Nosotros() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 991);

  useEffect(() => {
    document.title = 'Nosotros';
    const handleResize = () => setIsMobile(window.innerWidth < 991);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
    <section className="first-section-padding">
      <div style={{ position: 'relative', minHeight: '260px', overflow: 'hidden', background: "transparent", borderRadius: '33px 33px' }}>
        {/* Carousel de fondo */}
        <div
          id="carouselNosotros"
          className="nosotros-bg-carousel"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}
        >
          <div className="carousel-inner" style={{width: '100%', height: '100%' }}>
            <div className="carousel-item active">
              <img
                src={
                  window.innerWidth < 991
                    ? process.env.PUBLIC_URL + '/nosotros/linea-movil.webp'
                    : process.env.PUBLIC_URL + '/nosotros/linea.webp'
                
                }
                className="d-block w-100 nosotros-bg-img"
                alt="Línea del tiempo 1"
                style={{ 
                 width: '100%',
                  height: '100%',
                  //opacity: '0.4',
                  objectFit: 'cover',
                  objectPosition: 'center',
                  minHeight: '220px', // Ajusta este valor si necesitas un mínimo para móvil
                  borderRadius: '33px 33px'}}
              />
            </div>
            {/*<div className="carousel-item">
              <img
                src={process.env.PUBLIC_URL + '/nosotros/linea2.png'}
                className="d-block w-100 nosotros-bg-img"
                alt="Línea del tiempo 2"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>*/}
          </div>
        </div>

        {/* Línea del tiempo vertical y eventos */}
        <div className="container position-relative nosotros-timeline-content" style={{ zIndex: 2 }}>
          <div className='row'>
            <div className='timeline-heightcontainer'>
            {/* Línea vertical */}
            <div style={{
              position: 'absolute',
              left: '45%',
              top: 0,
              bottom: 0,
              /*width: '3px',*/
              /*background: '#bcbcbc',*/
              zIndex: 2
            }}></div>
            {/* Eventos */}
            <div className='first-timelinecontainer'>
              <div className='timeline-container'>
                {/* Evento 1965 */}
                <div className="timeline-event-bootstrap">
                  <div className="timeline-year">1965</div>
                  <div className="d-flex align-items-start mt-2 timeline-row">
                    <div className="timeline-line first-line"></div>
                    <div className="timeline-text">
                      <p className="txt2">
                        Inicia el sueño para una mejor visión.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Evento 1981 */}
                <div className="timeline-event-bootstrap">
                  <div className="timeline-year">1981</div>
                  <div className="d-flex align-items-start mt-2 timeline-row">
                    <div className="timeline-line second-line"></div>
                    <div className="timeline-text">
                      <p className="txt2">
                        Se adquiere nuestro primer laboratorio óptico.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Evento 1992 */}
                <div className="timeline-event-bootstrap">
                  <div className="timeline-year">1992</div>
                  <div className="d-flex align-items-start mt-2 timeline-row">
                    <div className="timeline-line third-line"></div>
                    <div className="timeline-text">
                      <p className="txt2">
                        Lanzamos la primera óptica móvil de Veracruz, llevando a las empresas y ciudades del Estado todas las comodidades de nuestras ópticas.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          {/* Segunda fila: Imagen y texto institucional */}
          <div className="row align-items-center mt-5 px-md-5 pb-md-auto pb-3 pdg-txtline">
            <div className="col-lg-3 col-md-12 text-center mb-3 mb-md-0">
              <img src={process.env.PUBLIC_URL + '/nosotros/logo60.png'} alt="60 años viéndote, ver" className="img-fluid nosotros-60anos-img" />
            </div>
            <div className="col-lg-9 col-md-12">
              <div className="nosotros-timeline-text ps-lg-5 ps-md-3">
                <p className="timeline-text txt2">
                  Cumplimos <span style={{ color: 'var(--first-color)', textTransform: 'uppercase', fontWeight: 'bold'}}>60 años creciendo</span> para nuestros clientes, con <b>4 sucursales estratégicas</b> en la zona conurbada Veracruz-Boca del Río.
                  Con las ópticas más equipadas y los licenciados en optometría más especializados.
                </p>
                <p className="timeline-text txt2"  >
                  Por eso es casi seguro que alguien de tu familia en Veracruz ha usado unos lentes de OPV Óptica París.
                </p>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
    {/* Segunda sección: Compromiso con el Futuro */}
    <section className="second-section-padding section-bottom-border py-5 ">
      <div className="container-fluid ps-md-5 ">
        <div className="row">
          {/* Columna de texto */}
          <div className="col-md-7 px-5">
            <h1 className="mb-0 title2 graytitle2" style={{fontFamily: 'Merriweather', color: '#575757', textAlign:'start'}}>Compromiso</h1>
            <h1 className="mb-4 title2 redtitle2" style={{fontFamily: 'Merriweather', color: 'var(--first-color)', fontStyle: 'italic', textAlign:'start'}}>con el Futuro</h1>
            <p className="timeline-text txt2" style={{textAlign: 'justify'}}>
              Hoy, <b style={{color: 'var(--first-color)'}}>ÓPTICA PARÍS</b> es una marca en constante crecimiento, adaptándose a los avances tecnológicos para ofrecerte lo mejor en soluciones visuales. Nuestra evolución está enmarcada en el mismo espíritu que define a Veracruz: un lugar que no solo mira al pasado, sino que siempre avanza hacia el futuro.
            </p>
            <p className="timeline-text txt2" style={{textAlign: 'justify'}}>
              Estamos aquí para acompañarte en cada paso de tu camino, ofreciendo lo mejor de nosotros mismos, con la visión clara de que el futuro será aún más brillante para todos.
            </p>
          </div>
          {/* Columna de imagen */}
          <div className="col-md-5 px-md-0 ps-5 pe-0">
            <img src={process.env.PUBLIC_URL + '/nosotros/compromiso-futuro.webp'} alt="Compromiso con el futuro" style={{width: '100%'}} />
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default Nosotros; 